import BlanaceTable from 'components/table/balanceTable';
import { useTranslation } from 'react-i18next';
import { OverviewDetail, OverviewDetailReponse } from 'models/overview';
import { getLaminasApiData } from 'services/api';
import { useEffect, useState } from 'react';
import {
  useParams, Link, useNavigate,
} from 'react-router-dom';
import Alert from 'components/alert';
import Header, { HeaderModifier } from 'components/header';
import Btn, { BtnModifier } from 'components/btn';
import ArrowLeftIcon from 'assets/icons/arrowLeft.svg';


export interface OverviewDetailsProps {
  liveOnly?: boolean;
}

function OverviewDetailsComponent(props: OverviewDetailsProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { type, name, wallet } = useParams();
  const { liveOnly = false } = props;
  const [overviewDetail, setOverviewDetail] = useState<OverviewDetail | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [currentMismatch, setCurrentMismatch] = useState<boolean | undefined>(undefined);
  const [userCurrencyMismatch, setUserCurrencyMismatch] = useState<boolean | undefined>(undefined);

  const getOverviewDetail = (_type: string, _name: string, _wallet: string, _liveOnly: string) => getLaminasApiData<OverviewDetailReponse>(`/tx-overview-v1/platform/detail?platform-type=${_type}&platform-name=${_name}&wallet-address=${_wallet}&live-only=${_liveOnly}`);

  useEffect(() => {
    getOverviewDetail(
      type || '',
      name || '',
      wallet ? encodeURIComponent(wallet) : '',
      liveOnly ? '1' : '0'
    ).then((res: OverviewDetailReponse) => {
      const overviewDetailData = res.data;
      setOverviewDetail(overviewDetailData);
      setIsLoading(false);
    }, () => { });
  }, []);

  return (
    <div className="ct_padding">
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <div className="ct_overviewDetailsHeader">
              <div className="ct_overviewDetailsHeader-main">
                <Header
                  headline={overviewDetail ? `${overviewDetail?.display_name} ${t('Balance', { ns: 'overview' })}` : `${t('Balance', { ns: 'overview' })}`}
                  desc={t('This detail page contains a list of your coins with the live balance reported by the exchange/wallet and the imported balance.', { ns: 'overview' })}
                  modifiers={[
                    HeaderModifier.OLD, HeaderModifier.OLD_MARGIN,
                  ]}
                />
              </div>
              <div className="ct_overviewDetailsHeader-aside">
                <Btn
                  onClick={() => {
                    navigate('/overview-v1', {
                      state: { data: currentMismatch, dataCurrency: userCurrencyMismatch },
                    });
                  }}
                  type="primary"
                  text={t('Back to Overview', { ns: 'overview' })}
                  icon={<ArrowLeftIcon />}
                  modifier={[BtnModifier.OLD]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ct_section _oldView">
        <div className="ct_section-inner">
          <div className="ct_overviewDetailsHeader-anchor _old">
            {!!hasError && (
            <Alert type="error" hasArrow={false} title="Error">
              <>
                {type && t(
                  'No {{type}} found using this name.',
                  { type: type === 'custom' ? 'platform' : type },
                  { ns: 'overview' },
                )}
                {' '}
                <Link
                  to={{
                    pathname: '/import',
                  }}
                  state={{
                    data: currentMismatch,
                    dataCurrency: userCurrencyMismatch,
                  }}
                  className="ct_link _bold"
                >
                  {t('Start importing your trades here', { ns: 'overview' })}
                </Link>
                .
              </>
            </Alert>
            )}
            {!hasError && (
              <BlanaceTable
                pageSize={100}
                requestUri={`/tx-overview-v1/platform/balance?platform-type=${type || ''}&platform-name=${name || ''}&wallet-address=${wallet ? encodeURIComponent(wallet) : ''}&live-only=${liveOnly ? '1' : '0'}`}
                onErrorCB={() => setHasError(true)}
                setCurrentMismatch={(value: boolean) => setCurrentMismatch(value)}
                setUserCurrencyMismatch={(value: boolean) => setUserCurrencyMismatch(value)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverviewDetailsComponent;
